import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  pt: {
    translation: translationPT,
  },
};

i18n
  .use(LanguageDetector) // detecta o idioma do navegador
  .use(initReactI18next) // conecta com React
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react já faz isso
    },
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [], // <- desativa localStorage/cookie
    },
  });

export default i18n;
